import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
} from "@chakra-ui/react";
import { useAtualizarTabelaProcedimento } from "../hooks/useTabelaProcedimento";

const EditarTabelaModal = ({ isOpen, onClose, tabela }) => {
  const atualizarTabela = useAtualizarTabelaProcedimento();
  const [nome, setNome] = useState("");
  const [tipo, setTipo] = useState("convenio");

  useEffect(() => {
    if (tabela) {
      setNome(tabela.nome || "");
      setTipo(tabela.tipoTabelaProcedimento || "convenio");
    }
  }, [tabela]);

  const handleSalvar = () => {
    if (!tabela?._id) return;
    atualizarTabela.mutate(
      { id: tabela._id, data: { nome, tipoTabelaProcedimento: tipo } },
      { onSuccess: onClose }
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Editar tabela de procedimentos</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome da tabela</FormLabel>
            <Input value={nome} onChange={(e) => setNome(e.target.value)} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Flag (uso)</FormLabel>
            <Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="convenio">Somente Convênio</option>
              <option value="particular">Somente Particular</option>
              <option value="ambos">Convênio e Particular</option>
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSalvar} isLoading={atualizarTabela.isPending}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditarTabelaModal;
